<script setup lang="ts">
import { RouterLink } from 'vue-router'
import ScrollProgress from './ScrollProgress.vue'

const year = new Date().getFullYear()
</script>

<template>
  <footer class="footer">
    <div class="footer__copyright">
      <div class="container container--wide footer__copyright-inner">
        <div class="footer__copyright-content">
          <p>
            Copyright &copy; {{ year }} <a href="/">
              Bar Bluff
            </a>. The perfect game to run your mouth at!
          </p>
        </div>
        <div class="footer__copyright-list">
          <ul>
            <li>
              <RouterLink to="/join">
                Join a game
              </RouterLink>
            </li>
            <li><span /></li>
            <li>
              <RouterLink to="/admin">
                Host console
              </RouterLink>
            </li>
            <li><span /></li>
            <li>
              <RouterLink to="/install">
                Setup
              </RouterLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <ScrollProgress />
  </footer>
</template>
